/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_Notification_TitleInputs */

const en_admin_email_settings_notification_title = /** @type {(inputs: Admin_Email_Settings_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Notifications`)
};

const de_admin_email_settings_notification_title = /** @type {(inputs: Admin_Email_Settings_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Benachrichtigungen`)
};

/**
* | output |
* | --- |
* | "Admin Notifications" |
*
* @param {Admin_Email_Settings_Notification_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_notification_title = /** @type {((inputs?: Admin_Email_Settings_Notification_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_Notification_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_notification_title(inputs)
	return en_admin_email_settings_notification_title(inputs)
});